import type { Filter_FacetsFragment } from '@generated/graphql'

type TFacets = Filter_FacetsFragment[] | []
/**
 * @export
 * @description function to organize facets
 * @param {facets[] | null} facets the facets values
 * @returns the ordered array
 */

export const useFilteredFacets = (facets: TFacets) => {
  const [...rest] = facets.filter(
    (elem) => elem.key !== 'category-1' && elem.key !== 'price'
  )

  const [price] = facets.filter((elem) => elem.key === 'price')

  const [departament] = facets.filter((elem) => elem.key === 'category-1')

  if (departament && price) {
    return [departament, ...rest, price]
  }

  if (price) {
    return [...rest, price]
  }

  return [...rest]
}
